import React, { useContext } from 'react';
import ContentBox from 'Components/common/ContentBox/ContentBox';
import { AppContext } from 'App.context';
import styles from './Modals.styles';
import Colors from 'constants/Colors';

export default function CheckinFieldsReplica({
  customStyles = {},
  logoImage = null,
}) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const {
    textAndBorderColor = Colors.darkText,
    backgroundColor = 'var(--color-content-box-bg)',
    buttonColor = '#ccc',
  } = customStyles;

  const checkboxLabels = [
    { key: 'dataPrivacyPolicy', id: 'privacy' },
    { key: 'loyaltyProgram', id: 'loyalty' },
    { key: 'dataComercialUse', id: 'commercial' },
  ];

  const outerWrapperStyle = {
    backgroundColor,
    padding: 16,
    borderRadius: 16,
  };

  const buttonStyle = {
    ...styles.disabledButton,
    backgroundColor: buttonColor,
    color: '#fff',
  };

  const checkboxLabelStyle = {
    ...styles.checkboxLabel,
    color: textAndBorderColor,
  };

  const fieldLabelStyle = {
    ...styles.fieldLabel,
    color: textAndBorderColor,
  };

  return (
    <div style={outerWrapperStyle}>
      <div style={styles.contentWrapper}>
        <div
          style={{
            position: 'relative',
            padding: '12px 8px',
            backgroundColor: 'transparent',
            borderRadius: '1rem',
            marginBottom: 16,
            height: 120,
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 16,
              left: 16,
              padding: '6px 14px',
              fontSize: 14,
              fontWeight: 'bold',
              border: `1px solid ${textAndBorderColor}`,
              borderRadius: '1rem',
              color: textAndBorderColor,
              backgroundColor: 'transparent',
              backgroundColor: '#fff',
            }}
          >
            {translate(`quickguide.back`)}
          </div>

          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              width: 80,
              height: 80,
              border: `2px solid ${textAndBorderColor}`,
              borderRadius: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              backgroundColor: '#fff',
            }}
          >
            {logoImage ? (
              <img
                src={logoImage}
                alt="logo"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <span style={{ fontSize: 24, color: textAndBorderColor }}>+</span>
            )}
          </div>
        </div>

        {['documentType', 'documentNumber', 'name', 'surname', 'secondSurname', 'address'].map(
          fieldKey => (
            <div
              key={fieldKey}
              style={{
                ...styles.checkinFields,
                borderColor: textAndBorderColor,
                backgroundColor: '#fff',
              }}
            >
              <label style={fieldLabelStyle}>
                {translate(`policeReport.detailFields.${fieldKey}`)}
              </label>
            </div>
          )
        )}

        <div
          style={{
            ...styles.checkboxContainer,
            borderColor: textAndBorderColor,
            backgroundColor: '#fff',
          }}
        >
          {checkboxLabels.map(({ key, id }, idx) => (
            <div key={idx} style={styles.checkboxItem}>
              <input type="checkbox" id={`check-${id}`} disabled />
              <label htmlFor={`check-${id}`} style={checkboxLabelStyle}>
                {translate(`legalDocuments.${key}`)}
              </label>
            </div>
          ))}
        </div>

        <div style={buttonStyle}>{translate('legalDocuments.continue')}</div>
      </div>
    </div>
  );


}
